// src/components/dashboard/RegistrationFormTerminal.jsx
import React, { useState, useEffect } from 'react';
import { X, Calendar, Truck } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import useAuth from '../../hooks/useAuth';
import { nowLocalInput } from '../../utils/time';

const RegistrationFormTerminal = ({ isOpen, onClose, onSubmit, initialData }) => {
  const { t } = useLanguage();
  const { user } = useAuth();
  
  const [formData, setFormData] = useState({
	company: initialData?.company || '',
    number: initialData?.number || '',
    trailer_number: initialData?.trailer_number || '',
    departure_date: initialData?.departure_date || nowLocalInput(),
    entry_point: initialData?.entry_point || '',
	exit_point: initialData?.exit_point || '',
    terminal_entry_date: initialData?.terminal_entry_date ? initialData.terminal_entry_date.slice(0, 16) : '',
    terminal_exit_date: initialData?.terminal_exit_date ? initialData.terminal_exit_date.slice(0, 16) : '',
    exitPoint_entry_date: initialData?.exitPoint_entry_date ? initialData.exitPoint_entry_date.slice(0, 16) : '',
    exitPoint_exit_date: initialData?.exitPoint_exit_date ? initialData.exitPoint_exit_date.slice(0, 16) : '',
    natakhtari_entry_date: initialData?.natakhtari_entry_date ? initialData.natakhtari_entry_date.slice(0, 16) : '',
    natakhtari_exit_date: initialData?.natakhtari_exit_date ? initialData.natakhtari_exit_date.slice(0, 16) : '',
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
		company: initialData.company || '',
        number: initialData.number || '',
        trailer_number: initialData.trailer_number || '',
        departure_date: initialData.departure_date || nowLocalInput(),
        entry_point: initialData.entry_point || '',
		exit_point: initialData.exit_point || '',
        terminal_entry_date: initialData.terminal_entry_date ? initialData.terminal_entry_date.slice(0, 16) : '',
        terminal_exit_date: initialData.terminal_exit_date ? initialData.terminal_exit_date.slice(0, 16) : '',
        exitPoint_entry_date: initialData.exitPoint_entry_date ? initialData.exitPoint_entry_date.slice(0, 16) : '',
        exitPoint_exit_date: initialData.exitPoint_exit_date ? initialData.exitPoint_exit_date.slice(0, 16) : '',
        natakhtari_entry_date: initialData.natakhtari_entry_date ? initialData.natakhtari_entry_date.slice(0, 16) : '',
        natakhtari_exit_date: initialData.natakhtari_exit_date ? initialData.natakhtari_exit_date.slice(0, 16) : '',
      });
    } else {
      setFormData({
		company: '',
        number: '',
        trailer_number: '',
        departure_date: nowLocalInput(),
        entry_point: '',
		exit_point: '',
        terminal_entry_date: '',
        terminal_exit_date: '',
        exitPoint_entry_date: '',
        exitPoint_exit_date: '',
        natakhtari_entry_date: '',
        natakhtari_exit_date: '',
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (formData.number === '') {
      alert(t('fillNumber'));
      return;
    }
	  const submitData = {
    ...formData,
    exitPoint_entry_date: formData.exitPoint_entry_date || null,
    exitPoint_exit_date: formData.exitPoint_exit_date || null,
	terminal_entry_date: formData.terminal_entry_date || null,
    terminal_exit_date: formData.terminal_exit_date || null,
	natakhtari_entry_date: formData.natakhtari_entry_date || null,
    natakhtari_exit_date: formData.natakhtari_exit_date || null,
  };
    
    onSubmit(submitData);
  };

  if (!isOpen) return null;

  const entryPoints = [
    { value: '', label: t('select') },
    { value: 'daryal', label: t('daryal') },
    { value: 'murphy', label: 'Murphy' },
    { value: 'no_need', label: t('no_need') }
  ];
   const exitPoints = [
    { value: '', label: t('select') },
	{ value: 'bagratashen', label: t('bagratashen') }, 
    { value: 'gogavan', label: t('gogavan') }
   ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl overflow-hidden max-h-[90vh] flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-neutral-200 bg-gradient-to-r from-slate-800 to-slate-700 text-white">
          <h2 className="text-xl font-semibold">
            {initialData ? t('editRegistration') : t('newRegistration')}
          </h2>
          <button
            onClick={onClose}
            className="p-2 text-white hover:text-gray-200 rounded-full transition duration-150"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          <form onSubmit={handleSubmit}>
            {/* Vehicle Info */}
            <div className="mb-6">
              <h3 className="text-lg font-medium text-gray-800 mb-4 pb-2 border-b border-gray-200">
                {'Info'}
              </h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className={`block text-sm font-medium mb-1 ${formData.number === '' ? 'text-red-600' : 'text-gray-700'}`}>
                    {'Truck Number'} *
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Truck className={`h-5 w-5 ${formData.number === '' ? 'text-red-500' : 'text-gray-400'}`} />
                    </div>
                    <input
                      type="text"
                      name="number"
                      value={formData.number}
                      onChange={handleChange}
                      required
                      disabled={!!initialData}
                      className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-primary-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                      style={{ textTransform: 'uppercase' }}
                    />
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {'Trailer Number'}
                  </label>
                  <input
                    type="text"
                    name="trailer_number"
                    value={formData.trailer_number}
                    onChange={handleChange}
                    disabled={!!initialData}
                    className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    style={{ textTransform: 'uppercase' }}
                  />
                </div>
              </div>
            </div>

            {/* Dates */}
            <div className="mb-6">
              <h3 className="text-lg font-medium text-gray-800 mb-4 pb-2 border-b border-gray-200">
                {'Dates'}
              </h3>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {user?.role !== 'gugutivertex' && user?.role !== 'sadakhlovertex'  && user?.role !== 'murphy'  &&(
				<>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {'Natakhtari Entry Date'}
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Calendar className="h-5 w-5 text-gray-400" />
                    </div>
                    <input
                      type="datetime-local"
                      name="natakhtari_entry_date"
                      value={formData.natakhtari_entry_date}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {'Natakhtari Exit Date'}
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Calendar className="h-5 w-5 text-gray-400" />
                    </div>
                    <input
                      type="datetime-local"
                      name="natakhtari_exit_date"
                      value={formData.natakhtari_exit_date}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    />
                  </div>
                </div>
				</>
				)}			  
			  
			  
			  

                {user?.role !== 'gugutivertex' && user?.role !== 'sadakhlovertex'  && user?.role !== 'natakhtari'  &&(
				<>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {'Parking Entry Date'}
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Calendar className="h-5 w-5 text-gray-400" />
                    </div>
                    <input
                      type="datetime-local"
                      name="terminal_entry_date"
                      value={formData.terminal_entry_date}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {'Parking Exit Date'}
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Calendar className="h-5 w-5 text-gray-400" />
                    </div>
                    <input
                      type="datetime-local"
                      name="terminal_exit_date"
                      value={formData.terminal_exit_date}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    />
                  </div>
                </div>
				</>
				)}
				{user?.role !== 'murphy' && user?.role !== 'natakhtari' &&(
				<>
				  <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {'Parking Entry Date'}
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Calendar className="h-5 w-5 text-gray-400" />
                    </div>
                    <input
                      type="datetime-local"
                      name="exitPoint_entry_date"
                      value={formData.exitPoint_entry_date}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {'Parking Exit Date'}
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Calendar className="h-5 w-5 text-gray-400" />
                    </div>
                    <input
                      type="datetime-local"
                      name="exitPoint_exit_date"
                      value={formData.exitPoint_exit_date}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    />
                  </div>
                </div>
				</>
				)}
				
              </div>
            </div>

            {/* Entry Point */}

              {user?.role !== 'gugutivertex' && user?.role !== 'sadakhlovertex'  && user?.role !== 'natakhtari'  &&(
			  <div className="mb-6">
              <h3 className="text-lg font-medium text-gray-800 mb-4 pb-2 border-b border-gray-200">
                {'Parking Info'}
              </h3>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  {'Parking Point'}
                </label>
                <select
                  name="entry_point"
                  value={formData.entry_point}
                  onChange={handleChange}
				  disabled={!!initialData}
                  className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                >
                  {entryPoints.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
			  </div>
			  )}
			  
			  {user?.role !== 'murphy' && user?.role !== 'natakhtari'  &&(
			  <div className="mb-6">
              <h3 className="text-lg font-medium text-gray-800 mb-4 pb-2 border-b border-gray-200">
                {'Parking Info'}
              </h3>
			     <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  {'Parking Point'}
                </label>
                <select
                  name="exit_point"
                  value={formData.exit_point}
                  onChange={handleChange}
				  disabled={!!initialData}
                  className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                >
                  {exitPoints.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
			  </div>
			  )}
			  
			  
			  
            
          </form>
        </div>

        <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end space-x-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
          >
            {'Cancel'}
          </button>
          
          <button
            type="button"
            onClick={handleSubmit}
            className="px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors"
          >
            {initialData ? t('update') : t('save')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegistrationFormTerminal;